import { _ as __assign, e as __spreadArray, c as __read } from './tslib.es6-ebb56484.js';
import { c as cn } from './index-9d6795ea.js';
import React__default from 'react';
import { Typography, Icon, Sheet, Dialog } from '@sravni/react-design-system';
import { useAuthLoginLink, useIsMobile } from '@sravni/react-utils';
import { normalizeTab, hasItem } from '@sravni/ugc/lib/specialOffers/helpers';
import { EDUCATION_OFFERS_LIST, COMMON_OFFERS_LIST } from '@sravni/ugc/lib/specialOffers/lists';
import { g as getTabTitle } from './getTitle-6237901b.js';
import { A as ArrowRight } from './ArrowRight-40285519.js';

var modules_17a50390 = {"background":"_pam76n","dialog":"_ilutqo","sheet":"_9jwkl0","dialog__header":"_tnyj1q","dialog__content":"_1fg1zyc","sheet__content":"_13ak28e","contentLoaded":"_1b9jke5","dialog__authorizationLink":"_tt3r1a","sheet__authorizationLink":"_135s9os","authorizationLink--withAllOffersLink":"_1x7nlyu"};
import "../assets/PopupForSpecialOffersWithAuthorization.css";

var AuthorizationLink = function (_a) {
    var className = _a.className, onClick = _a.onClick;
    var link = useAuthLoginLink();
    return (React__default.createElement(Typography.Text, { size: 14, strong: true, className: className },
        React__default.createElement(Typography.Link, __assign({}, link, { onClick: onClick }), "\u0412\u043E\u0439\u0434\u0438\u0442\u0435"),
        ", \u0447\u0442\u043E\u0431\u044B \u043E\u0442\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u044D\u0442\u0438 \u0443\u0432\u0435\u0434\u043E\u043C\u043B\u0435\u043D\u0438\u044F ",
        React__default.createElement(Icon, { size: 20, icon: React__default.createElement(ArrowRight, null), style: { verticalAlign: 'middle' } })));
};

var PopupForSpecialOffersWithAuthorization = function (_a) {
    var _b, _c;
    var children = _a.children, onClose = _a.onClose, wasShown = _a.wasShown, canBeVisible = _a.canBeVisible, isContentLoaded = _a.isContentLoaded, propsActiveTab = _a.activeTab, pushEvent = _a.pushEvent;
    var isMobile = useIsMobile();
    var activeTab = propsActiveTab && normalizeTab(propsActiveTab);
    var isVisible = !wasShown && canBeVisible;
    var contentLoadedStyles = (_b = {},
        _b[modules_17a50390.contentLoaded] = isContentLoaded,
        _b);
    var authorizationLinkStyles = __assign({}, (activeTab && (_c = {},
        _c[modules_17a50390['authorizationLink--withAllOffersLink']] = hasItem(__spreadArray(__spreadArray([], __read(COMMON_OFFERS_LIST), false), __read(EDUCATION_OFFERS_LIST), false), activeTab),
        _c)));
    var handleClickAuthorizationLink = function () {
        return activeTab &&
            pushEvent({
                event: 'mainEvent',
                eventCategory: getTabTitle(activeTab),
                eventAction: 'Войдите|Попап',
                eventLabel: undefined,
                eventValue: undefined
            });
    };
    return isMobile ? (React__default.createElement(Sheet, { visible: isVisible, onClose: onClose, closable: true, className: cn(modules_17a50390.sheet, modules_17a50390.background) },
        React__default.createElement(Sheet.Content, { className: cn(modules_17a50390.sheet__content, contentLoadedStyles) },
            children,
            React__default.createElement(AuthorizationLink, { className: cn(modules_17a50390.sheet__authorizationLink, authorizationLinkStyles), onClick: handleClickAuthorizationLink })))) : (React__default.createElement(Dialog, { visible: isVisible, onClose: onClose, className: cn(modules_17a50390.dialog, modules_17a50390.background) },
        React__default.createElement(Dialog.Content, { className: cn(modules_17a50390.dialog__content, contentLoadedStyles) },
            children,
            React__default.createElement(AuthorizationLink, { className: cn(modules_17a50390.dialog__authorizationLink, authorizationLinkStyles), onClick: handleClickAuthorizationLink }))));
};

export { PopupForSpecialOffersWithAuthorization as P, modules_17a50390 as m };
